import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=2d4852ea&"
import script from "./Attachments.vue?vue&type=script&lang=js&"
export * from "./Attachments.vue?vue&type=script&lang=js&"
import style0 from "./Attachments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports